module.exports = __webpack_public_path__ + "scripts/search-clear.svg?bffc6d60";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-clear.svg
// module id = 1466
// module chunks = 1